import { Dimensions, Platform } from "react-native"

if (Platform.OS === 'web') {
  function _update() {
    const win = Dimensions.get('window');
    win.width = (win.width > 480) ? 480 : win.width;
  }
  _update()
  window.addEventListener('resize', _update, false)
}
